import styles from './table.module.scss';
import React, {CSSProperties} from 'react';

interface OwnProps {
    children?: React.ReactNode;
    style?: CSSProperties;
}

export function TableList({children, style}: OwnProps) {
    return (
        <div style={style} className={styles.table_list}>
            {children}
        </div>
    );
}
